<script setup lang="ts">
import type { UrlMetadata } from "ls/features/disko/api/urlMetadata.types";
import type { InlineCardNodeViewProps } from "../types";
import type { JiraMetadataMatch } from "./jira";
import { computed } from "vue";

const props = defineProps<InlineCardNodeViewProps & {
  match: JiraMetadataMatch;
  metadata?: UrlMetadata;
}>();

const label = computed(() => {
  if (props.node.attrs.text) return props.node.attrs.text;
  return props.match.key;
});

defineExpose({
  label,
});
</script>

<template>
  <component :is="match.icon" class="relative bottom-px mr-1 inline size-4" />
  <span>{{ label }}</span>
</template>
